import React from 'react'
import QuranView from './QuranView'

const PublicView = () => {
  return (
    <QuranView />
  )
}

export default PublicView